import api from '@/utils/api';
import {
    FETCH_CUSTOMERS,
    FETCH_ACTIVE_CUSTOMERS,
    FETCH_ORTHODONTIC_CUSTOMERS,
    FETCH_CUSTOMER,
    FETCH_CUSTOMER_BY_FB_NAME,
    CREATE_CUSTOMER,
    CREATE_CUSTOMER_FROM_PROSPECT,
    CREATE_CUSTOMER_FROM_CHAT,
    UPDATE_CUSTOMER,
    UPDATE_CUSTOMER_FROM_CHAT,
    DELETE_CUSTOMERS,
    EXPORT_CUSTOMERS_EXCEL,
    SET_CUSTOMER_PRIMARY_PHONE,
    FETCH_NEXT_MEDICAL_BOOK_NUMBER,
    FETCH_CUSTOMER_PHONES
} from './types';

import { NotificationManager } from 'react-notifications';

const CUSTOMERS_ENDPOINT = '/customers';

export const fetchCustomers = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(CUSTOMERS_ENDPOINT, { params: filter })
            .then((res) => {
                dispatch({ type: FETCH_CUSTOMERS, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const fetchOrthodonticCustomers = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(`${CUSTOMERS_ENDPOINT}/orthodontic-customers`, { params: filter })
            .then((res) => {
                dispatch({ type: FETCH_ORTHODONTIC_CUSTOMERS, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const fetchActiveCustomers = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(`${CUSTOMERS_ENDPOINT}/active`, { params: filter })
            .then((res) => {
                dispatch({ type: FETCH_ACTIVE_CUSTOMERS, payload: res.data.data });
                resolve(res.data);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const fetchCustomer = (id, filter = {}) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(`${CUSTOMERS_ENDPOINT}/${id}`, { params: filter })
            .then((res) => {
                dispatch({ type: FETCH_CUSTOMER, payload: res.data.data });
                //console.log('fetchCustomer', res.data.data);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const reconcileCustomerDebt = (id) => () => {
    return api
        .post(`${CUSTOMERS_ENDPOINT}/${id}/reconcile-debt`)
        .then((res) => res.data.data)
        .catch((err) => Promise.reject(err));
};

export const previewCustomerFinancialRepair = (id) => () => {
    return api
        .get(`${CUSTOMERS_ENDPOINT}/${id}/financial-repair`)
        .then((res) => res.data.data)
        .catch((err) => Promise.reject(err));
};

export const executeCustomerFinancialRepair = (id, data) => () => {
    return api
        .post(`${CUSTOMERS_ENDPOINT}/${id}/financial-repair`, data)
        .then((res) => res.data.data)
        .catch((err) => Promise.reject(err));
};

export const fetchCustomerByFacebookName = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(`${CUSTOMERS_ENDPOINT}/facebook/name`, { params: filter })
            .then((res) => {
                dispatch({ type: FETCH_CUSTOMER_BY_FB_NAME, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const createCustomer = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .post(CUSTOMERS_ENDPOINT, data)
            .then((res) => {
                dispatch({ type: CREATE_CUSTOMER, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch((err) => {
                const status = err.response?.status;
                const msg = err.response?.data?.msg;

                // 409 nghiệp vụ (trùng SĐT) -> không toast
                if (status !== 409) {
                    NotificationManager.error(msg || 'Có lỗi xảy ra');
                }
                reject(err);
            });
    });
};

// Tạo khách hàng từ khách hàng tiềm năng
export const createCustomerFromProspect = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .post(`${CUSTOMERS_ENDPOINT}/from-prospect`, data)
            .then((res) => {
                dispatch({ type: CREATE_CUSTOMER_FROM_PROSPECT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const createCustomerFromChat = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .post(`${CUSTOMERS_ENDPOINT}/create/from-chat`, data)
            .then((res) => {
                dispatch({ type: CREATE_CUSTOMER_FROM_CHAT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const updateCustomer = (id, data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .put(`${CUSTOMERS_ENDPOINT}/${id}`, data)
            .then((res) => {
                dispatch({ type: UPDATE_CUSTOMER, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch((err) => {
                const status = err.response?.status;
                const msg = err.response?.data?.msg;

                if (status !== 409) {
                    NotificationManager.error(msg || 'Có lỗi xảy ra');
                }
                reject(err);
            });
    });
};

export const updateCustomerFromChat = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .put(`${CUSTOMERS_ENDPOINT}/update/from-chat`, data)
            .then((res) => {
                dispatch({ type: UPDATE_CUSTOMER_FROM_CHAT, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const deleteCustomers = (ids) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .delete(CUSTOMERS_ENDPOINT, { data: { ids } })
            .then((res) => {
                dispatch({ type: DELETE_CUSTOMERS, payload: ids });
                NotificationManager.success(res.data.msg);
                resolve(res.data);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const exportCustomersExcel = (filter) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .post(`${CUSTOMERS_ENDPOINT}/export`, filter)
            .then((res) => {
                dispatch({ type: EXPORT_CUSTOMERS_EXCEL, payload: res.data.data });
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const fetchCustomerPhones = (customerId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(`${CUSTOMERS_ENDPOINT}/customer-phones/${customerId}`)
            .then((res) => {

                dispatch({
                    type: FETCH_CUSTOMER_PHONES,
                    payload: res.data.data
                });

                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const setCustomerPrimaryPhone = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .post(`${CUSTOMERS_ENDPOINT}/set-primary-phone`, data)
            .then((res) => {
                dispatch({ type: SET_CUSTOMER_PRIMARY_PHONE, payload: res.data.data });
                NotificationManager.success(res.data.msg);
                resolve(res.data.data);
            })
            .catch((err) => {
                NotificationManager.error(err.response?.data?.msg);
                reject(err);
            });
    });
};

export const fetchNextMedicalBookNumber = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        return api
            .get(`${CUSTOMERS_ENDPOINT}/next-medical-book-number`)
            .then((res) => {
                const next = res.data.data?.next_medical_book_number;
                dispatch({ type: FETCH_NEXT_MEDICAL_BOOK_NUMBER, payload: next });
                resolve(next);
            })
            .catch((err) => {
                console.log(err);
                NotificationManager.error(err.response?.data?.msg || 'Lấy mã sổ khám thất bại');
                reject(err);
            });
    });
};
